import React from 'react'
import ParticlesMain from './ParticlesMain'
import { TypeAnimation } from 'react-type-animation'
import { useTranslation } from 'react-i18next';




const Guncelleniyor = () => {

      const { t } = useTranslation();
  return (
    <div className='h-[calc(100vh-4.4rem)] bg-white flex justify-center items-center relative overflow-hidden'>
      <div className='absolute  px-[10%]'>
      <TypeAnimation
        sequence={[

      t('icerik-guncelleniyor'),
          1000

        ]}
        cursor={false}
        speed={1}
        className=' text-2xl md:text-4xl font-bold leading-none text-genesisBlue animate-changeOpacity1'
     

      />
      </div>


      <ParticlesMain />

    </div>
  )
}

export default Guncelleniyor